import { render, staticRenderFns } from "./GangJin.vue?vue&type=template&id=6f19fdbf&scoped=true&"
import script from "./GangJin.vue?vue&type=script&lang=js&"
export * from "./GangJin.vue?vue&type=script&lang=js&"
import style0 from "./GangJin.vue?vue&type=style&index=0&id=6f19fdbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19fdbf",
  null
  
)

export default component.exports